import { useIntl } from 'react-intl';
import TextField from '@mui/material/TextField';
import RepeaterList from '../../components/RepeaterList';
import type { SondagePhotoRow } from './sondagePhotoRows';

/**
 * The Sondagen opened on a Tagebuch day, each with the Teilfoto taken of it.
 *
 * One list rather than two fields, because a day regularly opens several and
 * the pair belongs together. Embedded on the diary doc (see the RxDB collection
 * cap), so the rows are plain state here and the form folds them into its dirty
 * check and its save (see `lastPartialPhotoNumber`).
 */
export default function DiarySondagePhotoEditor({
    value,
    onChange
}: {
    value: SondagePhotoRow[];
    onChange: (rows: SondagePhotoRow[]) => void;
}) {
    const intl = useIntl();

    return (
        <RepeaterList
            rows={value}
            onChange={onChange}
            blankRow={{ sondage: '', partialPhoto: '' }}
            labelId="diary.field.sondagePhotos"
            emptyId="diary.sondagePhoto.empty"
            addId="diary.sondagePhoto.add"
            removeId="diary.sondagePhoto.remove"
            renderRow={(row, update) => (
                <>
                    <TextField
                        label={intl.formatMessage({
                            id: 'diary.field.lastSondageNumber'
                        })}
                        value={row.sondage}
                        onChange={(event) =>
                            update({ sondage: event.target.value })
                        }
                        sx={{ flex: 1 }}
                    />
                    <TextField
                        label={intl.formatMessage({
                            id: 'diary.field.lastPartialPhotoNumber'
                        })}
                        value={row.partialPhoto}
                        onChange={(event) =>
                            update({ partialPhoto: event.target.value })
                        }
                        sx={{ flex: 1 }}
                    />
                </>
            )}
        />
    );
}
